import TemplatesPage from '@/views/templates/TemplatesPage'

export default function Page() {
  return <TemplatesPage />
}
